module.exports = __webpack_public_path__ + "media/assets/svg/components/hexagon_outline_cropped-0fd974ccd32a22401c527544c6edd705.svg";